import { FC, useMemo, useCallback } from 'react'
import styles from 'components/features/socialFeed/ComposeActions/ComposeActions.styl'
import cn from 'classnames'
import { createComposeImagesSelector } from 'selectors/feedComposeSelectors'
import { WithComposeId } from 'interfaces/feed'
import { useShallowSelector, useStoreDispatch } from 'helpers/reactReduxHelpers'
import { FEED_POST_MAX_IMAGES_COUNT } from 'constants/feed'
import ImageSvg from 'icons/upload_image.svg'
import SvgIcon from 'components/atoms/SvgIcon'
import { AnalyticsClick } from 'components/features/pfm/AnalyticsClick/AnalyticsClick'
import { FileInput } from 'components/features/pfm/FileInput/FileInput'
import { feedComposeAddImageAttemptActionCreator, composeExecCommandActionCreator } from 'actions/feedComposeActions'

type AddImageButtonProps =
  & WithComposeId

export const AddImageButton: FC<AddImageButtonProps> = (props) => {
  const { composeId } = props
  const composeImagesSelector = useMemo(createComposeImagesSelector, [])
  const images = useShallowSelector((state) => composeImagesSelector(state, props))

  const content = useMemo(() => (
    <button className={ styles.actionContent }>
      <div className={ styles.actionIcon }>
        <SvgIcon src={ ImageSvg } />
      </div>
      Image
    </button>
  ), [])

  const dispatch = useStoreDispatch()

  const handleAddImage = useCallback<(files: File[]) => void>((files) => {
    dispatch(feedComposeAddImageAttemptActionCreator.request({ files, composeId }))
    dispatch(composeExecCommandActionCreator({
      composeId,
      command: {
        type: 'focus',
      },
    }))
  }, [composeId, dispatch])

  const canAdd = images.length < FEED_POST_MAX_IMAGES_COUNT
  if (!canAdd) {
    return (
      <div className={ cn(styles.action, styles.disabled) }>
        { content }
      </div>
    )
  }

  return (
    <div className={ styles.action }>
      <AnalyticsClick
        category='module-feed_compose'
        action='click-add_image'
      >
        <FileInput onChange={ handleAddImage } images multiple>
          { content }
        </FileInput>
      </AnalyticsClick>
    </div>
  )
}
